<template>
  <layout-auth>
    <v-container class="py-10">
      <v-row class="py-10">
        <v-col cols="12" sm="12" md="1"></v-col>
        <v-col cols="12" sm="12" md="3">
          <img
            :src="
              currentConfig.isError
                ? basePath + 'assets/images/login/error.svg'
                : basePath + 'assets/images/login/succes@2x.png'
            "
            alt="logo"
            style="max-width: 100%"
          />
        </v-col>
        <v-col cols="12" sm="12" md="1"></v-col>

        <v-col cols="12" sm="12" md="6">
          <v-col cols="12" sm="12" md="11">
            <h1 class="text-h4 font-weight-light">
              {{ currentConfig.title }}
            </h1>

            <p class="text-h6 font-weight-light my-6">
              {{ currentConfig.message }}
            </p>
          </v-col>

          <v-col cols="12" sm="12" md="12" class="my-10">
            <div class="float-end" v-if="!currentConfig.isError">
              <v-btn
                depressed
                dark
                :color="entityConfig.primaryColor"
                :style="`color: ${entityConfig.secondaryColor}`"
                @click="$router.push(currentConfig.btnUrl)"
              >
                {{ currentConfig.btnText }}
              </v-btn>
            </div>

            <div class="float-end" v-else>
              <v-btn
                outlined
                dark
                :color="entityConfig.primaryColor"
                class="mx-2"
                @click="$router.push(currentConfig.btnUrl)"
              >
                {{ currentConfig.btnText }}
              </v-btn>
              <v-btn
                depressed
                dark
                :color="entityConfig.primaryColor"
                :style="`color: ${entityConfig.secondaryColor}`"
                @click="$router.go(-1)"
              >
                Reintentar
              </v-btn>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </layout-auth>
</template>

<script>
import LayoutAuth from "./layout-auth.vue";

export default {
  components: { LayoutAuth },
  data() {
    return {
      basePath: process.env.VUE_APP_CONTEXT_PATH,
      entityConfig: {},
      currentConfig: {
        title: "Algo salio mal",
        message: "No se ha podido completar la operacion",
        isError: true,
        btnText: "Ir al inicio",
        btnUrl: "/anticipo-automatico/consulta",
      },
      config: {
        altaAnticipoOk: {
          title: "¡Todo listo!",
          message: "Se ha creado un nuevo anticipo automático",
          isError: false,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
        altaAnticipoError: {
          title: "Oh no, algo ha ido mal",
          message:
            "Lo sentimos, no podemos continuar con la operación. Por favor, espere unos minutos y vuelve a intentarlo.",
          isError: true,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
        editAnticipoOk: {
          title: "¡Todo listo!",
          message: "Hemos registrado los cambios",
          isError: false,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
        editAnticipoError: {
          title: "Oh no, algo ha ido mal",
          message:
            "Lo sentimos, no podemos continuar con la operación. Por favor, espere unos minutos y vuelve a intentarlo.",
          isError: true,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
        bajaAnticipoOk: {
          title: "¡Todo listo!",
          message: "Se ha dado de baja al anticipo automatico.",
          isError: false,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
        bajaAnticipoError: {
          title: "Oh no, algo ha ido mal",
          message:
            "Lo sentimos, no podemos continuar con la operación. Por favor, espere unos minutos y vuelve a intentarlo.",
          isError: true,
          btnText: "Ir a inicio",
          btnUrl: "/anticipo-automatico/consulta",
        },
      },
    };
  },
  mounted() {
    let status = this.$route.query.status;
    this.entityConfig = this.$store.state.entityConfig.config;
    if (status && Object.prototype.hasOwnProperty.call(this.config, status)) {
      this.currentConfig = this.config[status];
    }
  },
};
</script>